import './banner.css';  


const Banner = () => {
    return (
        <div className="banner">
            <h1>Chez vous, partout et ailleurs</h1>
            <img src="/images/homebackgroundimg.png" alt="banner" />
        </div>
    )
}

export default Banner;